/* The manager row (handover answer 3, 12/10; Technical's manager pack, `lib/merchant.js › canBuild`): the owner, the
   administrators and a manager write campaigns, cadeaux, roues and demandes, and choose the campagne principale; a
   Collaborateur (staff) writes none of them. The screens hide what the API would refuse (403 forbidden_role), so a
   Collaborateur reads every page and never meets the refusal. Billing stays the owner's (routes/parametres), supports and
   the till keep their own rules (lib/campaign-api supportRefusal, routes/equipe/Caisse). The demo's user is the world
   switcher's (lib/scope currentUser); with an API it is the session's. */
import { currentUser, type Role } from '@/lib/scope'

/** Writes campaigns, cadeaux, roues and demandes: every role but the Collaborateur. */
export const canBuild = (role: Role = currentUser().role): boolean => role !== 'staff'

/** The app's one line for a Collaborateur on a page whose actions are not theirs (⟦confirmable⟧, D-82). */
export const READ_ONLY_LINE = 'Votre rôle ne permet pas de gérer les campagnes, les cadeaux et les demandes : vous les consultez.'
